import React, { useCallback, useMemo } from 'react';
import { useField } from 'formik';
import MuiPhoneNumber from 'material-ui-phone-number';
import PropTypes from 'prop-types';
import { useFormContext } from '../../contexts/formContext';
import Tooltip from '../Tooltip';
import useFieldStyles from './Field.styles';

const PhoneField = ({ name, label, disabled }) => {
  const fieldClasses = useFieldStyles();

  const [field, meta, helpers] = useField({ name });

  const handleChange = useCallback(
    (value) => {
      helpers.setValue(value);
    },
    [helpers]
  );

  const { disabled: formDisabled } = useFormContext();

  const errorMessage = useMemo(() => (meta.touched && meta.error ? meta.error : ''), [meta.touched, meta.error]);

  return (
    <Tooltip title={errorMessage} placement="bottom" classes={{ tooltip: fieldClasses.tooltip }}>
      <MuiPhoneNumber
        id={name}
        inputClass={fieldClasses.root}
        defaultCountry="ca"
        onlyCountries={['ca']}
        disableAreaCodes
        name={field.name}
        value={field.value}
        label={label}
        onChange={handleChange}
        disableDropdown
        error={!!(meta.touched && meta.error)}
        disabled={formDisabled || disabled}
      />
    </Tooltip>
  );
};

PhoneField.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
};

PhoneField.defaultProps = {
  disabled: false,
  label: '',
};

export default React.memo(PhoneField);
